import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "main-app"
}
const _hoisted_2 = {
  ref: "main",
  class: "main"
}
const _hoisted_3 = { style: {"display":"flex","flex":"1"} }
const _hoisted_4 = { class: "imdex-loading-container" }
const _hoisted_5 = {
  key: 1,
  class: "imdex-loading-error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_LayoutContainer = _resolveComponent("LayoutContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isLoading && !_ctx.connectionError)
            ? (_openBlock(), _createBlock(_component_imdex_spinner, {
                key: 0,
                size: 3,
                width: 150,
                color: "#808080"
              }))
            : _createCommentVNode("", true),
          (_ctx.connectionError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "fadeIn",
          "leave-active-class": "fadeOut"
        }, {
          default: _withCtx(() => [
            (_ctx.panelLayout != null && _ctx.api != null && _ctx.siteStore.activeSite != null)
              ? (_openBlock(), _createBlock(_component_LayoutContainer, {
                  key: 0,
                  class: "animated",
                  ref: "layoutContainer",
                  children: _ctx.panelLayout.children || false,
                  componentState: _ctx.panelLayout.componentState,
                  id: _ctx.panelLayout.id
                }, null, 8, ["children", "componentState", "id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass([{ dragging: _ctx.isDragging }, "right-drop-zone"])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([{ dragging: _ctx.isDragging }, "left-drop-zone"])
        }, null, 2)
      ])
    ], 512)
  ]))
}